//商品接口数据
import request from "@/untils/request.js"

// 码上放心追溯码上传记录-分类分页查询
export const traceCodeUploadRecord = (params) => {
	return request.get("/outpatient/msfx/traceCodeUploadRecord/page", {params})
}